import { connect } from "react-redux";
import _ from "lodash";

import { fetchEngagementShareGraphReport } from "src/legacy/redux/actions/reports.jsx";
import withUseHooks from "src/legacy/components/withUseHooks";

import ShareView from "./view";

const mapStateToProps = (state, ownProps) => {

  return {
    loading: state.legacyRootReducer.reports.engagement.sharesGraph.loading,
    data: state.legacyRootReducer.reports.engagement.sharesGraph.item,
    count : _.sumBy(state.legacyRootReducer.reports.engagement.sharesGraph.item, (item) => item.value)

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEngagementSharesGraphReport: (filter) => {
      return dispatch(fetchEngagementShareGraphReport(filter));
    },
  };
};

const ShareViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareView);

export default withUseHooks(ShareViewContainer);